import React, { useContext } from "react";
import LanguageContext from "../utils/Contexts/LanguageContext";
import ThemeContext from "../utils/Contexts/ThemeContext";

function ImportFilterModal({
  allParsing,
  allProcessing,
  setActiveParsTab,
  activeParsTab,
  setActiveProcessTab,
  activeProcessTab,
  updatePendingFilter,
  pendingFilters,
  setFormData,
}) {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);

  const handleProcessTabClick = (placementValue) => {
    setActiveProcessTab(placementValue);
    updatePendingFilter("PROCESSING", placementValue);
  };

  const handleParsTabClick = (relValue) => {
    setActiveParsTab(relValue);
    updatePendingFilter("PARSING", relValue);
  };

  const applyFilters = () => {
    setFormData((prevData) => {
      let updatedFilters = prevData.search.filters.filter(
        (existingFilter) =>
          !pendingFilters.some((pf) => pf.key === existingFilter.key)
      );

      updatedFilters = [
        ...updatedFilters,
        ...pendingFilters.filter((filter) => filter.value !== null),
      ];

      return {
        ...prevData,
        search: {
          ...prevData.search,
          filters: updatedFilters,
        },
      };
    });
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
    // Hide modal after applying filters
    const modalElement = document.getElementById("offcanvasImportFilter");
    if (modalElement) {
      modalElement.classList.remove("show");
    }
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.remove();
    }
  };

  const handleClearFilters = () => {
    setFormData((prevData) => {
      return {
        ...prevData,
        search: {
          ...prevData.search,
          filters: prevData.search.filters.filter(
            (filter) => filter.key !== "PROCESSING" && filter.key !== "PARSING"
          ),
        },
      };
    });
    setActiveProcessTab(null);
    setActiveParsTab(null);
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    // Hide modal
    const modalElement = document.getElementById("offcanvasImportFilter");
    if (modalElement) {
      modalElement.classList.remove("show");
    }
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.remove();
    }
  };

  return (
    <div
      className="offcanvas offcanvas-end rounded-4"
      tabIndex="-1"
      id="offcanvasImportFilter"
      aria-labelledby="offcanvasImportFilterLabel"
      aria-hidden="true"
      style={{
        top: "21px",
        left: "auto",
        right: "auto",
        bottom: "21px",
        width: "calc(100% - 40px)",
        marginLeft: "20px",
        marginRight: "20px",
        border: selectedTheme === "dark" ? "2px solid rgba(45, 50, 54, 1)" : "1px solid rgb(172, 172, 172)",
      }}
    >
      <div
        className="offcanvas-header px-3 pb-3"
        style={{ borderBottom: selectedTheme === "dark" ? "2px solid rgba(45, 50, 54, 1)" : "1px solid rgb(172, 172, 172)" }}
      >
        <h3 id="offcanvasImportFilterLabel" className="mb-0 pb-0">
          {t("Filters")}
        </h3>
      </div>
      <div className="offcanvas-body px-3 pt-3">
        <div className="row d-xxxl-none d-flex">
          <div className="col-12">
            <span className="mb-2 text-secondary">{t("Parsing")} </span>
          </div>
        </div>
        <div className="row d-xxxl-none d-flex mb-3 mt-2">
          <div className="col-12">
            <div className="mb-2 js-nav-scroller hs-nav-scroller-horizontal col-12">
              <div className="col-12 text-center">
                <ul
                  className="nav nav-segment flex-wrap flex-sm-nowrap col-12 justify-content-between "
                  style={{
                    backgroundColor:
                      selectedTheme === "dark" ? "#1e2022" : "#f8fafd",
                    padding: "0.1rem",
                  }}
                  role="tablist"
                >
                  {allParsing.map((parsing) => (
                    <li className="nav-item col-4" key={parsing.value}>
                      <a
                        className={`js-loading-state-invoker nav-link ${
                          activeParsTab === parsing.value ? "active" : ""
                        } `}
                        id="nav-one-eg1-tab"
                        data-bs-toggle="pill"
                        href="#nav-one-eg1"
                        role="tab"
                        aria-controls="nav-one-eg1"
                        onClick={() => {
                          handleParsTabClick(parsing.value);
                        }}
                        data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                      >
                        {parsing?.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row d-xxl-none d-flex">
          <div className="col-12">
            <span className="mb-2 text-secondary">{t("Process")} </span>
          </div>
        </div>
        <div className="row mb-3 d-xxl-none d-flex mt-2">
          <div className="col-12">
            <div className="mb-2 js-nav-scroller hs-nav-scroller-horizontal col-12">
              <div className="col-12 text-center">
                <ul
                  className="nav nav-segment flex-wrap flex-sm-nowrap col-12 justify-content-between"
                  role="tablist"
                  style={{
                    backgroundColor:
                      selectedTheme === "dark" ? "#1e2022" : "#f8fafd",
                    padding: "0.1rem",
                  }}
                >
                  {allProcessing.map((process) => (
                    <li className="nav-item col-4" key={process.value}>
                      <a
                        className={`js-loading-state-invoker nav-link ${
                          activeProcessTab === process.value ? "active" : ""
                        }`}
                        id="nav-one-eg1-tab"
                        data-bs-toggle="pill"
                        href="#nav-one-eg1"
                        role="tab"
                        aria-controls="nav-one-eg1"
                        onClick={() => {
                          handleProcessTabClick(process.value);
                        }}
                        data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                      >
                        {process?.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="offcanvas-footer px-4 py-3">
        <div className="row gx-3">
          <div className="col">
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-outline-primary py-2"
                onClick={handleClearFilters}
              >
                {t("Clear All Filters")}
              </button>
            </div>
          </div>

          <div className="col">
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-primary py-2"
                onClick={applyFilters}
              >
                {t("Apply")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImportFilterModal;
